import { useAgentAssignedToClientQuery } from '@coverright/data-access/enrollment';
import { useUserProfile } from './use-user-profile';
import { enrollmentApolloClient } from '@coverright/data-access/apollo-clients';
import { AgentViewOutput } from '@coverright/data-access/types/enrollment';

const defaultAgent: AgentViewOutput = {
  id: '',
  email: 'katie@coverright.com',
  firstName: 'Katie',
  lastName: 'Lauer',
  phone: '+1 (646) 917-6996',
  picUrl: 'agent-avatar/268a67f2-32b3-4ea2-87ba-fb5a683603c3.jpeg',
  enrollmentMeetingUrl: 'https://calendly.com/coverright-advisors/enrollment',
  planReviewUrl: 'https://calendly.com/coverright-advisors/medicare-consultation-client',
  consultationUrl: 'https://calendly.com/coverright-advisors/medicare-consultation-client',
}

export const useAgent = () => {
  const profile = useUserProfile();
  const { data, loading } = useAgentAssignedToClientQuery({
    client: enrollmentApolloClient,
    variables: { clientId: profile?.clientId },
    skip: !profile?.clientId
  });

  const agent = profile?.clientId ? data?.agentAssignedToClient : defaultAgent;

  return { agent, loading: loading || !agent };
};
